import Swal from 'sweetalert2';
import { giveConsentTo } from '@/api/consent-forms';

export default {
  methods: {
    /**
     * Display the consent form and return the value chosen by the user.
     *
     * @param {Object} consentForm
     *
     * @return {Boolean}
     */
    async showConsentForm(consentForm) {
      let results = await Swal.fire({
        scrollbarPadding: false,
        width: '40%',
        title: consentForm.title.en,
        html: `<div class="text-justify tracking-tighter leading-normal">${consentForm.body.en}</div>`,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCancelButton: true,
        confirmButtonText: this.$t('messages.accept'),
        cancelButtonText: this.$t('messages.refuse')
      });

      return results.isConfirmed;
    }
  }
}